import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { IContext } from '@context/models/context';
import { RouteContextService } from '@context/services/route-context.service';
import { AdminOverviewTileService } from '@overview/services/admin-overview-tile.service';
import { ButtonWidget } from '@overview/models/button-widget';
import { DeviceDetectorService } from '@common/device-detection/services/device-detector.service';
import { DashboardScrollService } from '@dashboards/services/dashboard-scroll.service';
import { Direction } from '@common/enums/direction';

@Component({
  selector: 'mojo-admin-overview',
  templateUrl: './admin-overview.component.html'
})
export class AdminOverviewComponent implements OnInit {

  tiles$: Observable<Array<ButtonWidget>>;
  context: IContext;
  scrollDirection$: Observable<Direction>;
  scrollDown: Direction = Direction.Down;

  constructor(
    contextService: RouteContextService,
    activatedRoute: ActivatedRoute,
    private readonly adminOverviewTileService: AdminOverviewTileService,
    private readonly deviceDetectorService: DeviceDetectorService,
    dashboardScrollService: DashboardScrollService) {

    this.context = contextService.getContextFromRoute(activatedRoute);

    this.tiles$ = this.adminOverviewTileService.tiles;

    this.scrollDirection$ = dashboardScrollService.getScrollDirection();
  }

  ngOnInit() {
    this.adminOverviewTileService.loadTiles();
  }

  isMobile(): boolean {
    return this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet();
  }
}
